/*
 if we want to intercept the request to api (to add auth or sth)
 we need to add "fake" prefix %BD-API%/
 for details check 'mixins/componentConfiguration.js'
*/

module.exports = {
  REGISTER_SOFTWARE: '%BD-API%/engine_analyzer/authentication',
  RETRIEVE_PASSWORD: '%BD-API%/engine_analyzer/password',
  FEEDBACK_GET: '%BD-API%/survey/{survey_id}',
  FEEDBACK_SEND: '%BD-API%/survey/{survey_id}/response',
  FEEDBACK_UPDATE: '%BD-API%/survey/{survey_id}/response/{response_id}',
  COMPONENT_DETAILS: '%BD-API%/content/poc/component-details/{uuid}',
  BATS_TROUBLESHOOTING: '%BD-API%/{serial}/troubleshooting_charts/{code}',
  PRODUCTS_DETAILS: '%BD-API%/product/{serial}/details',
  SCHEMATICS_LIST: '%BD-API%/product/{serial}/schematics-v2',
  SCHEMATICS_DETAILS: '%BD-API%/product/{serial}/schematics-v2/{schematic_id}',
  SERVICE_LIBRARY_DOCUMENTS: '%BD-API%/product/documents',
  SERVICE_LIBRARY_DOCUMENT_DOWNLOAD: '%BD-API%/product/documents/{document_id}',
  SERVICE_LIBRARY_MANUALS: '%BD-API%/product/documents/manuals/{serial}',
  BULLETIN_DETAILS: '%BD-API%/documents/bulletins/{serial}',
  TRANSLATIONS: '%CONTENT-API%/public/concepts/kags/{path}',
  DP_CONCEPTS: '%CONTENT-API%/public/translations/dealer-portal/na/{path}',
  SITEMAP: '%CONTENT-API%/public/sitemap/kags',
  SAFETY_DOCS: '%CONTENT-API%/public/safety-docs/kags',
  OPTIONS_LIST: '%BD-API%/equipment/{serial}/options',
  TROUBLESHOOTING_GUIDES_LIST: '%BD-API%/troubleshooting/guides/serial/{serial}',
  TROUBLESHOOTING_SESSION_LIST: '%BD-API%/troubleshooting/sessions/serial/{serial}',
  TROUBLESHOOTING_SESSION_START: '%BD-API%/troubleshooting/{serial}/start/{guide_id}',
  TROUBLESHOOTING_SESSION_RESUME: '%BD-API%/troubleshooting/sessions/{session_id}/resume',
  TROUBLESHOOTING_SESSION_SUMMARY: '%BD-API%/troubleshooting/sessions/summary/{session_id}',
  TROUBLESHOOTING_SESSION_SUMMARY_PDF: '%BD-API%/troubleshooting/sessions/summary/{session_id}/pdf',
  FAULT_CODES_LIST: '%BD-API%/connected/v3/{serial}/fault_codes',
  MACHINE_DATA: '%BD-API%/connected/v3/{serial}',
  PRODUCT_PASSWORD: '%BD-API%/product/{serial}/password',
  PRODUCT_PASSWORD_UPDATE: '%BD-API%/product/{serial}/password/{panel}',
  LOCATION_DATA: '%BD-API%/connected/v3/{serial}/location',
  SERVICE_FIELD_MODIFICATIONS: '%BD-API%/equipment/{serial}/field_modifications?campaign_code={campaign_code}',
  SERVICE_LIBRARY_LETTERS: '%BD-API%/product/documents/service_letters/{field_mod_code}',
  SERVICE_MAINTENANCE_DETAILS: '%BD-API%/product/{serial}/service_details',
  FAULT_CODES_AUTOCOMPLETE: '%BD-API%/product/fault_codes?code_prefix={code_prefix}',
  WARRANTY_PLANS: '%BD-API%/equipment/{serial}/warranty_plans',
  WARRANTY_INCLUSIONS: '%BD-API%/equipment/{serial}/warranty_inclusions',
  MACHINE_SOFTWARE: '%BD-API%/product/{serial}/software/versions',
  ACCOUNT_SUBSCRIPTION: '%BD-API%/assets/{account}/{serial}',
  LATEST_SOFTWARE: '%BD-API%/product/software/{software}/latest',
  ACTIVE_NOTIFICATIONS: '%NOTIFICATIONS-API%/v2/announcements/active/dealer-home/{appId}?regionCodes=NA'
}
